import { Badge } from '@/components/ui/badge'
import type { InvoiceStatus } from '@/api/invoicing'
import { useTranslation } from 'react-i18next'

const STATUS_CONFIG: Record<InvoiceStatus, { className: string; key: string }> = {
  draft:     { className: 'bg-gray-100 text-gray-800 border-gray-200',       key: 'inv_status_draft' },
  sent:      { className: 'bg-blue-100 text-blue-800 border-blue-200',       key: 'inv_status_sent' },
  partial:   { className: 'bg-yellow-100 text-yellow-800 border-yellow-200', key: 'inv_status_partial' },
  paid:      { className: 'bg-green-100 text-green-800 border-green-200',    key: 'inv_status_paid' },
  cancelled: { className: 'bg-red-100 text-red-800 border-red-200',          key: 'inv_status_cancelled' },
}

interface InvoiceStatusBadgeProps {
  status: InvoiceStatus
}

export function InvoiceStatusBadge({ status }: InvoiceStatusBadgeProps) {
  const { t } = useTranslation()
  const config = STATUS_CONFIG[status] ?? STATUS_CONFIG.draft
  return (
    <Badge variant="outline" className={config.className}>
      {t(config.key)}
    </Badge>
  )
}

export function getAllowedActions(status: InvoiceStatus) {
  return {
    canSend:       status === 'draft',
    canEdit:       status === 'draft' || status === 'sent',
    canDelete:     status !== 'paid',
    canAddPayment: status === 'sent' || status === 'partial',
    canViewPdf:    status !== 'draft',
  }
}
